import { render, staticRenderFns } from "./JdhHeightTransition.vue?vue&type=template&id=5d481b41&scoped=true&"
import script from "./JdhHeightTransition.vue?vue&type=script&lang=ts&"
export * from "./JdhHeightTransition.vue?vue&type=script&lang=ts&"
import style0 from "./JdhHeightTransition.vue?vue&type=style&index=0&id=5d481b41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d481b41",
  null
  
)

export default component.exports